var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import React, { useContext } from 'react';
import { Context } from '../context';
function IconImageErrorComponent(props, ref) {
  var prefixFromContext = useContext(Context).prefix;
  var _a = props.className,
    className = _a === void 0 ? '' : _a,
    prefixFromProps = props.prefix,
    _b = props.width,
    width = _b === void 0 ? '1em' : _b,
    _c = props.height,
    height = _c === void 0 ? '1em' : _c,
    _d = props.useCurrentColor,
    useCurrentColor = _d === void 0 ? false : _d,
    rest = __rest(props, ["className", "prefix", "width", "height", "useCurrentColor"]);
  var prefix = prefixFromProps || prefixFromContext || 'arco';
  return /*#__PURE__*/React.createElement("svg", __assign({
    className: "".concat(prefix, "-icon ").concat(prefix, "-icon-image_error ").concat(className),
    width: width,
    height: height,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, rest, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.7432 3.78125H3.40991V37.1146H36.7432V3.78125ZM5.90991 34.6146V6.28125H34.2432V34.6146H5.90991ZM8.75012 15.3704C8.75012 12.8391 10.8021 10.7871 13.3334 10.7871C15.8647 10.7871 17.9167 12.8391 17.9167 15.3704C17.9167 17.9017 15.8647 19.9537 13.3334 19.9537C10.8021 19.9537 8.75012 17.9017 8.75012 15.3704ZM13.3334 13.2871C12.1828 13.2871 11.2501 14.2198 11.2501 15.3704C11.2501 16.521 12.1828 17.4537 13.3334 17.4537C14.484 17.4537 15.4167 16.521 15.4167 15.3704C15.4167 14.2198 14.484 13.2871 13.3334 13.2871ZM26.1617 20.2402L18.6987 25.7642L15.9787 22.8669L8.41675 28.5384L9.91675 30.5384L15.6881 26.2099L18.3983 29.0968L25.5051 23.8365L29.8329 30.5518L31.9343 29.1975L26.1617 20.2402Z",
    fill: useCurrentColor ? 'currentColor' : '#fff'
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39 32C39 28.134 35.866 25 32 25C28.134 25 25 28.134 25 32C25 35.866 28.134 39 32 39C35.866 39 39 35.866 39 32Z",
    fill: useCurrentColor ? 'currentColor' : '#EA3D4C'
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.2549 34.0836L28.8305 34.5077L29.6793 35.3558L30.1038 34.9317L31.9987 33.0383L33.9095 34.9476L34.3339 35.3717L35.1828 34.5235L34.7584 34.0994L32.8475 32.1901L34.8999 30.1395L35.3243 29.7154L34.4754 28.8672L34.051 29.2913L31.9987 31.342L29.9623 29.3072L29.5378 28.8831L28.689 29.7313L29.1134 30.1554L31.1498 32.1901L29.2549 34.0836Z",
    fill: useCurrentColor ? 'currentColor' : '#fff'
  }));
}
var IconImageError = /*#__PURE__*/React.forwardRef(IconImageErrorComponent);
export default IconImageError;